
function ProjectCreation() {

    /// <summary>
    /// This object provides client-side functions for the Widget.Project.Details visual. <br/>
   /// <br/>
    /// Author: MWI<br />
    /// Date: 12.05.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// *** v1.0.2 - 20.12.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - added textual switch on button between new customer and new project                      *<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 06.06.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - added support for more buttons                                   *<br />
    /// * - documentation                                                    *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 12.05.2016                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
   
}
ProjectCreation.prototype = new window.vcTemplate();
ProjectCreation.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it does nothing more than adding the clickhandler 
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        //me.showDevIcon("dev");
        me.initClickHandler();
        //me.visual.find("#divBackFromDetailsToProjectOverview").remove();
        me.visual.find("#divBtnNew").trigger("click").button("option", "disabled", true);
        return true;
    } catch (ex) {
        me.writeError('ProjectCreation.init', ex);
        return false;
    }

};

ProjectCreation.prototype.btnBack = function () {
    /// <summary>
    /// Handles the click of the back button <br/>
    /// by calling the webservice and calling the overview list again, needs to be 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        var visual = new window.vcVisual();
        visual.addVisualContentByName("divProject", "WIDGET_PROJECT_OVERVIEW_LIST", "Management", '27.11.2015', me.height, me.width, "", "", 1);
        return true;
    } catch (ex) {
        me.writeError('ProjectCreation.btnBack', ex);
        return false;
    }
};

ProjectCreation.prototype.loadDetailForms = function () {
    /// <summary>
    /// This functio is used for the various options in the logger/project/customer detailview. <br/>
    /// Currently the following types are supported <br/>
    /// <list type="bullet">
    /// <item>
    /// <description>'logger' loads the logger and device form</description>
    /// </item>
    /// <item>
    /// <description>'customer' loads the customer form</description>
    /// </item>
    /// <item>
    /// <description>'location' loads the geocoding widget</description>
    /// </item>
    /// <item>
    /// <description>'user2Logger' assignment of users to the current logger</description>
    /// </item>
    /// <item>
    /// <description>'rights2project' assignments of right-groups to the current logger</description>
    /// </item>
    /// </list>    
    /// </summary>
    var me = this;
    var type;
    try {

        if (me.error || me.visual.find(".button-toggle-active").button( "option", "disabled" )) { return false; }
        //init list entry click handler
        type = me.visual.find('.button-toggle-active').attr("data-projectdetail");
        me.vcVisual.setShowFullscreen(false);
        me.vcVisual.setShowHeaderMenu(false);
        me.visual.find("#detailContent").html(me.vcC.getLoadingIcon());
        me.visual.find("#detailContent").height(me.height - 200);
        switch (type) {
            case "logger":
                me.vcVisual.addVisualBaseByName('detailCont', 'WIDGET_PROJECT_PROJECTFORM', 'ent', window.getCurrentTimestamp(), me.height -200, me.width, '', JSON.stringify({ "newProject": true, "customerid": me.ids.customerid }), me.deviceType);
                break;
            case "customer":
                me.vcVisual.addVisualBaseByName('deta', 'WIDGET_PROJECT_CUSTOMERFORM', 'ilContent', window.getCurrentTimestamp(),me.height -200,me.width, '', JSON.stringify({ 'pid': me.ids.customerid }), me.deviceType);

                break;
        
            case "location":
                me.vcVisual.addVisualBaseByName('detailC', 'VISUAL_WIDGET_GEOCODING', 'ontent', window.getCurrentTimestamp(),me.height -200, me.width, "2" + "," + me.ids.deviceid.toString(), '', me.deviceType);

                break;
            case "user2logger":
                me.vcVisual.addVisualBaseByName('detailCo', 'VISUAL_MEMBERSHIP_ASSIGNMENT_USER2LOGGER', 'ntent', window.getCurrentTimestamp(),me.height -200,me.width, JSON.stringify({ "AssID": me.ids.loggerid }), "", me.deviceType);
                break;
            case "rights2project":
                me.vcVisual.addVisualBaseByName('detailCon', 'VISUAL_MEMBERSHIP_ASSIGNMENT_GROUP2SINGLELOGGER', 'tent', window. getCurrentTimestamp(), me.height -200, me.width, JSON.stringify({ "AssID": me.ids.loggerid }), "", me.deviceType);
                break;
    
            case "new":
                me.visual.find(".button-toggle:not(#divBtnNew)").button("option", "disabled", true).hide();
                window.VisualCoreService.getDataByName("WIDGET_PROJECT_CREATION", 'newFieldset1', window.getCurrentTimestamp(), me.height -200,me.width, '', '', 2, "", function (result) {                  
                    me.visual.find("#detailContent").html(result);
                    me.initNew();
                });
                break;
            case "contacts":
                me.vcVisual.addVisualBaseByName('detailCont', 'WIDGET_PROJECT_CONTACT_MANAGER', 'ent', window.getCurrentTimestamp(),  me.height -200, me.width, "", JSON.stringify({ 'loggerid': me.ids.loggerid }), me.deviceType);
                break;
            default:
                me.visual.find("#detailContent").html("button unbekannt");
                break;
        }


        return true;

    } catch (ex) { me.writeError("ProjectCreation.loadDetailForms", ex); return false; }
};

ProjectCreation.prototype.initNew = function () {
    /// <summary>
    /// initializes the small new Fieldset <br/>
    /// and goes through the loggers
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        //me.visual.find("#addNew").off("change").on("change", function () {
        //    // me.visual.find("#ddlCustomer").prop("disabled", false).trigger("chosen:updated");
        //   // me.visual.find("#ddlCustomer").prop("disabled", me.visual.find(".rdNew:checked").val() === "newCustomer").trigger("liszt:updated");

        //});
        me.visual.find(".rdNew").off("change").on("change", function() {
            var type =  $(this).val();
            switch (type) {
            case 'newCustomer':
                    me.visual.find("#btnCreate .ui-button-text").html("<i class='fa fa-building'></i><br/>" + me.resources.addCustomer);

               break;
            case 'newProject':
                    me.visual.find("#btnCreate .ui-button-text").html("<i class='fa fa-building'></i><br/>" + me.resources.addProject);

                break;
            default:
                me.showInfo("NO SUCH TYPE ", "", false);
                break;
            }
        });
        me.visual.find("#ddlCustomer").chosen({ max_selected_options: 1 });

        me.visual.find('#btnCreate').button().off("click").on("click", function () {
           var  type = me.visual.find(".rdNew:checked").val();
            switch(type) {
                case 'newCustomer':
                    me.visual.find("#names").html(me.resources.newCustomer + " - " + me.resources.newProject);

                    me.visual.find("#divBtnCustomer").button("option", "disabled", false).show().trigger("click");

                    break;
                case 'newProject':
                    me.ids.customerid = me.visual.find("#ddlCustomer option:selected").val();
                    me.visual.find("#names").html(me.visual.find("#ddlCustomer option:selected").html() + " - " + me.resources.newProject);
                    me.visual.find("#divBtnLoggerDevice").button("option", "disabled", false).show().filter("#divBtnLoggerDevice").trigger("click");
                    break;
                default:
                    me.showInfo("NO SUCH TYPE ", "", false);
                    break;
            }
        });

        return true;
    } catch (ex) {
        me.writeError('ProjectCreation.initNew', ex);
        return false;
    }
};
ProjectCreation.prototype.doEvent = function (event) {
    /// <summary>
    /// This function filters the events for ProjectCreation and acts accordingly
    /// <list type="bullet">
    /// <item>
    /// <description>'CUSTOMER_CHANGED' Called when a customer is changed and opens the projectform directly</description>
    /// </item>
    /// <item>
    /// <description>'PROJECT_SAVE' called when a project is saved and shows all other buttons like users, memberships</description>
    /// </item>
   /// </list>   
    /// </summary>
    var me = this;

    try {
        switch(event.msg) {
            case "CUSTOMER_CHANGED":
                me.visual.find("#names").html(me.visual.find("#txtCustomerName").val() + " - " + me.resources.newProject);
                me.ids.customerid = event.values.customerid;
                me.visual.find("#divBtnLoggerDevice").button("option", "disabled", false).show().trigger("click");

                me.visual.find("#divBtnCustomer").button("option", "disabled", true);

                break;
            case "PROJECT_SAVE":
                if (event.values.deviceid === -1) {
                    me.showInfo(me.resources.err_saveData, "", false);
                  } else {
                    me.ids.loggerid = event.values.loggerid;
                    me.ids.deviceid = event.values.deviceid;
                    me.visual.find("#names").html(me.visual.find("#names").html().replace(me.resources.newProject, me.visual.find("#txtLoggerName").val()));

                    me.visual.find(".button-toggle").not("#divBtnCustomer, #divBtnCredentials").button("option", "disabled", false).show().filter("#divBtnUserToLogger").trigger("click");

                    me.visual.find("#divBtnLoggerDevice").button("option", "disabled", true);
                }
                break;
        }
       
        return true;
    } catch (ex) { me.writeError('doEvent', ex); return false; }
};

ProjectCreation.prototype.initClickHandler = function () {
    /// <summary>
    /// initializes the clickhandler for the buttons back, and the toggle buttons<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        me.visual.find('#divBackFromDetailsToProjectOverview').button().off("click").on("click", function () {
            me.btnBack();
        });
        me.visual.find(".button-toggle").button().off("click").on("click", function () {
            me.visual.find(".button-toggle").removeClass("button-toggle-active");
            $(this).addClass("button-toggle-active");
            me.loadDetailForms();
        }).not("#divBtnNew").button({ "disabled": "disabled" });
        return true;
    } catch (ex) {
        me.writeError('ProjectCreation.initClickHandler', ex);
        return false;
    }
};

ProjectCreation.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('.toggle-button, #divContent').hide();
        }
        return true;
    } catch (ex) {
        me.writeError('specificInfoHandling', ex);
        return false;
    }
};